
    import '/opt/buildhome/repo/components/useXAgent/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["components-use-x-agent-demo-preset","components-use-x-agent-demo-custom"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/components/useXAgent/index.en-US.md?type=demo')
};